// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3kuxS","inputDescription":"styles_inputDescription__1ZHQB"};